import React, { Component } from 'react';
import type { ReactNode } from 'react';
import type { CalendarDate, Log, Project, User } from '../../../types';

type Props = {
  day: CalendarDate | { date?: string, dateString?: string },
  onOpenEditModal: (log: Log, date: string) => void,
  onAddDraggedLog?: (log: Log, date: string) => void,
  projects: Array<Project>,
  log: Log,
  currentUser?: User | any,
}

class TimeLog extends Component<Props> {
  getLogProjectTitle = (log: Log) => {
    const { projects } = this.props;
    if (!log.project_title) {
      const project = projects.find(p => Number(p.id) === Number(log.project_id));

      return project ? project.title : '';
    }

    return log.project_title;
  };

  render(): ReactNode {
    const {
      log, onOpenEditModal, day, onAddDraggedLog, projects, currentUser,
    } = this.props;
    const project = projects.find(p => Number(p.id) === Number(log.project_id));
    const projectTitle = this.getLogProjectTitle(log);
    const parsedTimeSpent = log.time_spent.toString().length >= 4 ? parseFloat(String(log.time_spent)).toFixed(2) : parseFloat(String(log.time_spent)).toFixed(1);

    const dragActions = onAddDraggedLog ? {
      onDragStart: (e: any) => {
        e.dataTransfer.setData('text/html', String(log.id)); // dummy data so drag works on firefox
        onAddDraggedLog(log, (day as any).date || (day as any).dateString);
      },
    } : {};

    return (
      <div
        className="edit-log note"
        onClick={() => onOpenEditModal(log, (day as any).date || (day as any).dateString)}
        draggable={project && project.active ? 'true' : 'false'}
        data-log-id={log.id}
        style={{ borderLeft: `solid ${log.category_color} 4px` }}
        title={log.category_name ?? undefined}
        {...dragActions}
      >
        <div className="clearfix">
          <input type="hidden" className="log-id" id={`log-id-${log.id}`} value={log.id} />
          <input type="hidden" className="project-id" id={`project-id-${log.project_id}`} value={log.project_id} />
          <div className="note-head">
            {log.changes && log.changes.length > 1 && currentUser && (currentUser?.isUserAdmin || currentUser?.isUserOwner) && <i className="fa fa-history" aria-hidden="true" />}
            <h5 className="log-title float-left" id={`log-title-${log.id}`}>
              {projectTitle}
            </h5>
            <h5 className="log-hours float-right" id={`log-hours-${log.id}`}>{parsedTimeSpent}</h5>
          </div>
        </div>
        <div className="clearfix">
          <p className="log-description mb-0">
            {log.overtime_type === 'incident' && (
              <i className="fa fa-exclamation-triangle mr-1" title="Incident" aria-hidden="true" />
            )}
            {log.overtime && log.overtime_type !== 'incident' && (
              <i className="fa fa-clock-o mr-1" title="overtime" aria-hidden="true" />
            )}
            {log.description}
          </p>
        </div>
      </div>
    );
  }
}

export default TimeLog;
